import React from 'react';

import CONFIG from '../../../config';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';


function Commercial({ data }) {
  return (
    <>
      <div className='divide-x col-span-12 grid grid-cols-12 gap-x-2 shrink-0 p-2 mb-2 bg-gray-100 rounded-md hover:border-ame-orange my-shadow cursor-pointer' onClick={() => window.open(CONFIG.BASE_URL + "/intranet/fiche/" + data._id, '_blank').focus()}>
        <div className='col-span-2 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
          {(data.nom.trim() === '' && data.prenom.trim() === '') ? 'Sans nom' : data.nom}
        </div>
        <div className='col-span-2 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
          {(data.nom.trim() === '' && data.prenom.trim() === '') ? '(' + data._id + ')' : data.prenom}
        </div>
        <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
          {{
            'osef': "Peu importe",
            'lyon': "Lyon",
            'paris': "Paris",
            'marseille': "Marseille",
            'bordeaux': "Bordeaux",
            'nantes': "Nantes",
            'rennes': "Rennes",
            'montpellier': "Montpellier",
            'toulouse': "Toulouse",
            'nice': "Nice",
            'reims': "Reims",
            'annemasse': "Annemasse",
            'autre': "Autre..."
          }[data.informations_admin.secteur]}
        </div>
        <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
          {((data.informations_admin.disponibilite === 'osef') ? '-' :
            ((data.informations_admin.disponibilite === 'conge') ? 'Congé' :
              ((data.informations_admin.disponibilite === '0d') ? '0' :
                ((data.informations_admin.disponibilite === '1d') ? '1' :
                  ((data.informations_admin.disponibilite === '2d') ? '2' :
                    ((data.informations_admin.disponibilite === '3d+') ? '3+' : ''))))))} 
        </div>
        <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
          {data.informations_admin.nb_clients_attribue} Client(s)
        </div>
        <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
          {data.informations_admin.nb_clients_propose} Client(s)
        </div>
        <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
          {data.informations_admin.nb_clients_valide} Client(s)
        </div>
        <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
          {!data.informations_admin.externe ? <CloseIcon className='text-red-600'></CloseIcon> : <CheckIcon className='text-green-600'></CheckIcon>}
        </div>
        <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
          {data.informations_admin.salaire} €
        </div>
        <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
          {data.informations_admin.prime} €
        </div>
      </div>
    </>
  );
}

export default Commercial;